const cards = [
  {
    tag: '热播剧',
    title: '《长安十二时辰》精编版',
    desc: '雷佳音、易烊千玺领衔主演，唐朝反恐24小时，豆瓣8.2分口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20historical%20drama%20aesthetic&width=500&height=320&seq=card-01-xian&orientation=landscape',
    meta: '48集全 · 8.2分',
  },
  {
    tag: '电影',
    title: '《流浪地球3》导演剪辑版',
    desc: '吴京、刘德华主演，中国科幻里程碑之作加长版，新增30分钟未曝光内容',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20city%20with%20massive%20planetary%20engines%20on%20frozen%20earth%20surface%2C%20epic%20sci-fi%20landscape%2C%20dramatic%20blue%20thruster%20lights%20against%20ice%2C%20cinematic%20wide%20shot&width=500&height=320&seq=card-02-earth&orientation=landscape',
    meta: '导演剪辑版 · 9.0分',
  },
  {
    tag: '综艺',
    title: '《向往的生活》第八季',
    desc: '黄磊、何炅领衔慢综艺，回归田园寻找生活本真，治愈系下饭综艺首选',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20with%20traditional%20wooden%20house%20and%20lush%20green%20rice%20fields%2C%20warm%20sunset%20lighting%2C%20cozy%20rural%20lifestyle%20aesthetic%2C%20natural%20and%20serene&width=500&height=320&seq=card-03-life&orientation=landscape',
    meta: '更新至第10期 · 9.1分',
  },
  {
    tag: '动漫',
    title: '《雾山五行·犀川幻紫林》',
    desc: '国风战斗美学巅峰，手绘水墨风格炸裂打戏，每一帧都能截下来做壁纸',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20martial%20arts%20scene%20in%20misty%20mountains%2C%20dynamic%20action%20with%20flowing%20ink%20effects%2C%20traditional%20watercolor%20aesthetic%2C%20elegant%20and%20powerful&width=500&height=320&seq=card-04-ink&orientation=landscape',
    meta: '全4集 · 9.4分',
  },
  {
    tag: '纪录片',
    title: '《风味人间》第五季',
    desc: '陈晓卿团队最新力作，跨越六大洲探寻食物本源，深夜慎点容易看饿',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20food%20photography%20with%20steaming%20dishes%20on%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20artisanal%20cooking%20scene%2C%20rich%20textures%20and%20appetizing%20colors%2C%20culinary%20documentary%20aesthetic&width=500&height=320&seq=card-05-food&orientation=landscape',
    meta: '全8集 · 9.3分',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            精选推荐
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            必看佳片
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            编辑团队从海量片库中为您精选的高分内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {cards.map((item) => (
            <article
              key={item.title}
              className="group bg-white rounded-2xl overflow-hidden hover:bg-primary-50/20 transition-colors duration-300"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-2 text-xs text-accent-600">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </div>
                  {item.meta}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}